import { Button } from '@/components/ui/button';
import { Check, Copy } from 'lucide-react';
import { useEffect, useRef, useState } from 'react';
import type { CopyLetterButtonProps } from './task-sheets.types';

const COPIED_FEEDBACK_MS = 2000;

/** Icon button that copies a task document to the clipboard, with brief "copied" feedback. */
export const CopyLetterButton = ({ text, disabled }: CopyLetterButtonProps) => {
  const [copied, setCopied] = useState(false);
  const resetTimer = useRef<ReturnType<typeof setTimeout>>(undefined);

  useEffect(() => () => clearTimeout(resetTimer.current), []);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(text);
    } catch {
      return;
    }
    setCopied(true);
    clearTimeout(resetTimer.current);
    resetTimer.current = setTimeout(() => setCopied(false), COPIED_FEEDBACK_MS);
  };

  const label = copied ? 'Afritað' : 'Afrita';
  return (
    <Button
      type="button"
      size="icon"
      variant="outline"
      aria-label={label}
      title={label}
      onClick={handleCopy}
      disabled={disabled || !text.trim()}
    >
      {copied ? <Check className="text-emerald-600" /> : <Copy />}
    </Button>
  );
};
